const formatValue = (value) => (value == null ? '—' : String(value));

// Maps Overview data sources into KPI card
const buildOverviewKPIs = ({
	openWorkItemsCount,
	overdueWorkItemsCount,
	openWorkItemsLoading,
	alertsTotalCount,
	alertStatus,
	criticalAlertsTotalCount,
	alertsLoading,
	selectedEntityName,
	fundProgress,
	fundProgressLoading,
	lpsInPipeline,
}) => [
	{
		label: 'Open work items',
		value: formatValue(openWorkItemsCount),
		sub: `${overdueWorkItemsCount} overdue`,
		subColor: 'down',
		loading: openWorkItemsLoading,
	},
	{
		label: alertStatus === 'acknowledged'
				? 'Acknowledged alerts'
				: 'Unacknowledged alerts',
		value: formatValue(alertsTotalCount),
		sub: `${formatValue(criticalAlertsTotalCount)} critical`,
		subColor: 'down',
		loading: alertsLoading,
	},
	{
		label: `${selectedEntityName} progress`,
		value: fundProgress ? `${fundProgress}% to target` : '—',
		sub: lpsInPipeline ? `${lpsInPipeline} LPs in Pipeline` : null,
		subColor: 'warn',
		loading: fundProgressLoading,
	},
];

export const buildCrmRecordUrl = (baseUrl, recordId) => {
	const base = baseUrl?.trim();
	const id = recordId?.trim();

	if (!base || !id) return null;

	return `${base.replace(/\/$/, '')}/${id}`;
}

export default buildOverviewKPIs;
